import { REMIX_APP_URL } from '../config/index';

function remixUrl(path: string) {
  return `${REMIX_APP_URL}${path}`;
}

export const RemixRoutes = {
  triage: remixUrl('/triage'),
};
